import { OrderOptionsEnum } from '../enums/OrderOptions';

export const printOrderOption = (optionInt: number) => {
    return OrderOptionsEnum[optionInt];
};
